module.exports = __webpack_public_path__ + "static/media/right.89b494f0.svg";